import { render, staticRenderFns } from "./add_project_modal.vue?vue&type=template&id=8a93bf10&scoped=true"
import script from "./add_project_modal.vue?vue&type=script&lang=js"
export * from "./add_project_modal.vue?vue&type=script&lang=js"
import style0 from "./add_project_modal.vue?vue&type=style&index=0&id=8a93bf10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a93bf10",
  null
  
)

export default component.exports